export const selectSubscriptionLoading = (state) =>
  state.subscription?.loading || false;
export const selectSubscriptionError = (state) =>
  state.subscription?.error || null;
export const selectUserSubscription = (state) =>
  state.subscription?.subscription || null;
export const selectCreateSuccess = (state) =>
  state.subscription?.createSuccess || false;
export const selectHasSubscription = (state) =>
  state.subscription?.hasSubscription || false;
export const selectSubscriptionFeatures = (state) =>
  state.subscription?.features || [];
export const selectSubscriptionPermissions = (state) =>
  state.subscription?.permissions || [];
